import React, { useCallback } from "react";
import PriceApplicationModal from "./index";
import { useModal } from "@/hooks/modals/useModal";

// ==================== 主组件 ====================
/**
 * PriceApplicationModal 适配器组件
 * 用于将 Modal 系统的 props 转换为 PriceApplicationModal 组件所需的 props
 *
 * 根据是否有 taskId 来决定显示查看模式还是编辑模式：
 * - 有 taskId: 显示查看/审批模式（从工作台点击进入）
 * - 无 taskId: 显示新增/编辑模式（从列表页点击进入）
 */
const PriceApplicationModalAdapter: React.FC = () => {
  const { open, props, closeModal } = useModal("JIA_GE_BIAN_GENG");
  const {
    mode,
    viewStatus,
    recordId,
    taskId,
    isReadOnly,
    supplierName,
    supplierUsName,
    navigate,
  } = props || {};

  // 处理关闭
  const handleClose = useCallback(() => {
    closeModal();
  }, [closeModal]);

  // 判断是否为只读模式
  const isReadOnlyMode =
    viewStatus === true || isReadOnly || mode === "inReview";

  // 在新建模式下，recordId 是 supplierCode
  // 在编辑/查看模式下，recordId 是 applicationId
  const isNewMode = mode === "started" && !taskId;
  const supplierCode = isNewMode ? (recordId as string) : "";
  const applicationId = !isNewMode ? recordId : undefined;

  return (
    <PriceApplicationModal
      visible={open}
      onClose={handleClose}
      supplierCode={supplierCode}
      supplierName={supplierName || ""}
      supplierUsName={supplierUsName || ""}
      applicationId={applicationId}
      taskId={taskId ? String(taskId) : undefined}
      isEdit={!!taskId}
      isView={isReadOnlyMode}
      viewStatus={viewStatus}
      navigate={navigate}
    />
  );
};

export default PriceApplicationModalAdapter;
